import { RouteConfig } from 'vue-router';

import { getPlan } from '@/utils/plan';

export const procedurePlanRoute: RouteConfig = {
  path: 'plan',
  name: 'procedurePlan',
  component: () => import(/* webpackChunkName: "ProcedurePlan" */ '@/views/mainRoute/procedure/details/Plan.vue'),
  meta: { breadcrumb: { title: 'Plan roczny' } },
  beforeEnter(to, from, next) {
    getPlan(to, next);
  }
};
